import React, { useEffect, useRef } from 'react'

const Cards = ({ cards }) => {
    const ref = useRef();

    useEffect(() => {
        const element = ref.current;
        const handleWheel = (e) => {
            if (element) {
                if (window.innerWidth >= 768) {
                    if (e.deltaY > 0 && element.scrollLeft < element.scrollWidth - element.clientWidth) {
                        element.scrollLeft += e.deltaY;
                    } else if (e.deltaY < 0 && element.scrollLeft > 0) {
                        element.scrollLeft += e.deltaY;
                    } else if (e.deltaY > 0) {
                        element.scrollTo({
                            left: 0,
                            top: element.scrollHeight,
                            behavior: 'smooth',
                        });
                    } else {
                        element.scrollTo({
                            left: 0,
                            behavior: 'smooth',
                        });
                    }

                    e.preventDefault(); // Prevent default vertical scroll
                }
            }
        };

        if (element) {
            // Add event listener with passive: false
            element.addEventListener('wheel', handleWheel, { passive: false });
        }

        // Remove event listener on component unmount
        return () => {
            if (element) {
                element.removeEventListener('wheel', handleWheel);
            }
        };
    }, [ref]);

    return (
        <div className="w-full lg:mx-auto mt-6 lg:overflow-x-auto flex lg:flex-row flex-col items-center lg:gap-0 gap-5 no-scrollbar" ref={ref}>
            {cards?.map((card, index) => (
                
                        <div className="flex flex-col flex-shrink-0 h-full w-96 space-x-6 px-5" key={index}>
                            <div className="bg-white rounded-md overflow-auto shadow-md">
                                <div className="px-6 py-4">
                                    <p className="text-gray-700 text-base font-semibold">"{card?.body}"</p>
                                    <div className='flex flex-col text-end items-end justify-end'>
                                    <div className="font-bold text-xl mb-2 text-end">{card?.title}</div>
                                    <p className='text-xs text-end'>{card?.details}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
        </div>
    )
}

export default Cards